import contact from "../assets/images/contact.png";
import mail from "../assets/icons/mail.png";
import linkdein from "../assets/icons/Linked.png";
import facebook from "../assets/icons/facebook.png";
import twitter from "../assets/icons/twitter.png";

function Contact() {
  return (
    <section
      id="contact"
      className="text-center relative  w-[90vw] m-auto flex flex-col justify-start items-center pb-14"
    >
      <h2 className="text-[48px] max-sm:text-[30px] font-bold text-yellow max-sm:mb-5 text-center">
        Contact Me
      </h2>
      <p className="w-[50%] m-auto max-lg:w-[60%] max-sm:w-[90%] max-sm:text-[12px]">
        I'd love to hear from you! If you have any questions, feedback, or
        collaboration opportunities, please reach out. Your message matters, and
        I'm here to connect with you. Use the contact form or email me directly.
        Let's get in touch
      </p>
      <img src={contact} alt="world png" className="h-[50vh] max-sm:h-[30vh]" />
      <div className="btns flex justify-between items-center max-md:flex-col max-md: gap-4 flex-wrap">
        <a
          href="mailto:abdelkarim98elalaoui@gmil.com"
          target="__blank"
          className="text-[12px] bg-white  flex justify-center  items-center gap-2  p-5 border max-sm:w-full rounded-lg"
        >
          <img src={mail} alt="mail" />
          abdelkarim98elalaoui@gmail.com
        </a>
        <a
          target="__blank"
          href="https://api.whatsapp.com/send?phone=0659322899"
          className="text-[12px] bg-white  flex justify-start items-center gap-2  p-5 border max-sm:w-full rounded-lg"
        >
          <img src={linkdein} alt="mail" />
          +212659322899
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61550895400758"
          target="__blank"
          className="text-[12px] bg-white  flex justify-start items-center gap-2  p-4 border max-sm:w-full rounded-lg"
        >
          <img src={facebook} alt="mail" />
          @karim_prime
        </a>
        <a
          href="https://twitter.com/karimPrime98"
          target="__blank"
          className="text-[12px] bg-white  flex justify-start items-center gap-2  p-5 border max-sm:w-full rounded-lg"
        >
          <img src={twitter} alt="mail" />
          @karim7398
        </a>
      </div>
    </section>
  );
}

export default Contact;
